import addMembersModal from "../contextModal/AddMembers";
import { IPageAddCallback, Names } from "./index";
import { lang } from "../context";
import { ActionFnEnum, ActionType, FileType } from "../types";
import {
  folderTypeEnum,
  getJoySpaceReadAllPermission,
  getJoySpaceReadFolderPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadPagePermission,
  getJoySpaceReadWritePermission,
  joyspacePermissionType
} from "../config/permissions.config";
import { PermissionEnum } from "../permissions";
import { getFileInfo } from "../reloadUtils";
import { getShareIdByPermissionType } from "../api/permissions";
import events from "../context/events";
import { analysisLog } from "@/utils/logAnalytics";
import { getLoactionFrom } from "./utils";

// eslint-disable-next-line max-params
const Collaborate: IPageAddCallback = (props, isAllow, isTeam, context) => {
  const { data, clearSelect, gname, name, setData, from } = props;
  const { id, permissions } = data;

  const folderType = gname
    ? folderTypeEnum.GROUP
    : name === Names.MY_SPACE
    ? folderTypeEnum.MY
    : folderTypeEnum.SHARE;

  let fileType = data.page_type ? FileType.Page : FileType.Folder;
  let type = data.type as any;
  let permissionType = getJoySpaceReadOnlyPermission();

  if (type && type === folderTypeEnum.MY) {
    permissionType = getJoySpaceReadAllPermission();
  } else if (fileType === FileType.Page && type === folderTypeEnum.MY) {
    permissionType = getJoySpaceReadWritePermission();
  } else if (fileType === FileType.Page) {
    permissionType = getJoySpaceReadPagePermission(permissions);
  } else if (type && type === folderTypeEnum.SHARE && fileType === FileType.Folder) {
    permissionType = getJoySpaceReadFolderPermission(permissions);
  }
  // 埋点上报
  const handleAnalysisLog = () => {
    // @ts-ignore
    const { id, type, page_type } = data;
    const rType = (page_type || type).toString();
    let rFrom = from;
    if (!rFrom) {
      rFrom = getLoactionFrom();
    }
    analysisLog("xtbg_jzb_joyspace_home_1676548210761", "42", rFrom, id, rType);
  };

  return [
    {
      children: lang("ctx.share_manage.title"),
      icon: "ic_pc_glxzz_doc",
      splitCode: 1,
      callbackOrModal: () => {
        handleAnalysisLog();
        addMembersModal({
          id,
          type: fileType,
          folderType,
          permissions,
          permissionType,
          title: "管理协作者",
          onOk: async () => {
            const result = await getShareIdByPermissionType(id);
            if (
              result === joyspacePermissionType.ReadDel ||
              result === joyspacePermissionType.ReadNothing
            ) {
              fileType === FileType.Folder &&
                setData({ type: ActionFnEnum.REMOVE, id, actionType: ActionType.Folder } as any);
              fileType === FileType.Folder && events.emit("deleteFolderById", id);
              return;
            }
            // const res: any = await getFileInfo(fileType, id);
            // if (res === joyspacePermissionType.ReadNothing) {
            //   console.error("操作失败");
            //   return;
            // }
            // if (res && typeof res === "object") {
            //   res.isFolder = res.page_type ? FileType.Page : FileType.Folder;
            //   !("title" in res) && (res.title = res.name);
            // }
            // console.log(data, "==>111", res, { ...data, ...res });
            // setData({ type: ActionFnEnum.ADDMEMBERS, newItem: { ...res, ...data }, id } as any);
          }
        });
      },
      isAllow,
      type: "collaborate",
      allowTips: "已开启安全设置，不支持此操作"
    }
  ];
};

export default Collaborate;
